
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import type { SubscriptionType } from '@/types/subscription';

interface SignUpFormFieldsProps {
  username: string;
  email: string;
  password: string;
  subscriptionType: SubscriptionType;
  onUsernameChange: (value: string) => void;
  onEmailChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onSubscriptionTypeChange: (value: SubscriptionType) => void;
}

export const SignUpFormFields = ({
  username,
  email,
  password,
  subscriptionType,
  onUsernameChange,
  onEmailChange,
  onPasswordChange,
  onSubscriptionTypeChange,
}: SignUpFormFieldsProps) => {
  return (
    <>
      <div>
        <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-1">
          Username
        </label>
        <Input
          id="username"
          type="text"
          value={username}
          onChange={(e) => onUsernameChange(e.target.value.startsWith('@') ? e.target.value : '@' + e.target.value)}
          placeholder="@username"
          required
          className="w-full"
        />
      </div>
      
      <div>
        <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
          Email
        </label>
        <Input
          id="email"
          type="email"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          required
          className="w-full"
        />
      </div>

      <div>
        <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
          Password
        </label>
        <Input
          id="password"
          type="password"
          value={password}
          onChange={(e) => onPasswordChange(e.target.value)}
          required
          minLength={6}
          className="w-full"
        />
        <p className="text-sm text-gray-500 mt-1">
          Password must be at least 6 characters long.
        </p>
      </div>

      <div>
        <label htmlFor="subscription" className="block text-sm font-medium text-gray-700 mb-1">
          Subscription Plan
        </label>
        <Select value={subscriptionType} onValueChange={onSubscriptionTypeChange}>
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Select subscription" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="select">Select subscription</SelectItem>
            <SelectItem value="monthly">Monthly $9.99 USD/month</SelectItem>
            <SelectItem value="yearly">Yearly $100.00 USD/year (Save 17%)</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="text-xs text-muted-foreground space-y-1 border-t pt-2">
        {(subscriptionType === 'monthly' || subscriptionType === 'yearly') && (
          <p className="font-semibold text-foreground text-sm">
            MindNote Pro — {subscriptionType === 'monthly' ? '$9.99 USD/month, auto-renews monthly' : '$100.00 USD/year ($8.33/month), auto-renews yearly. Save 17%'}
          </p>
        )}
        <p className="text-[10px]">
          Payment charged to your Apple ID at purchase. Auto-renews unless cancelled at least 24 hours before period end. Manage in Settings &gt; Apple ID &gt; Subscriptions.
        </p>
        <p className="text-[10px] text-muted-foreground">
          By clicking Continue, you agree to our{' '}
          <a href="https://www.mindnote.online/privacy" target="_blank" rel="noopener noreferrer" className="underline text-primary font-medium">
            Privacy Policy
          </a>
          {' '}and{' '}
          <a href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/" target="_blank" rel="noopener noreferrer" className="underline text-primary font-medium">
            Terms of Use (EULA)
          </a>.
        </p>
      </div>

    </>
  );
};
